// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"230":"8830e081","581":"55248797","671":"6d3d213a","690":"5fdaea17","844":"a776762f","995":"5fdaea17"}[chunkId] + ".chunk.css";
};